import { IconType } from "react-icons";
import { FaHistory, FaTrash, FaReceipt } from "react-icons/fa";
import { RiBankFill, RiDashboardFill, RiDraftFill, RiContactsBookFill, RiSurveyFill } from "react-icons/ri";
import { HiDocument, HiDocumentReport, HiCreditCard } from "react-icons/hi";
import { AiFillDatabase } from 'react-icons/ai';
import { Dashboard } from "../pages/Dashboard";
import SalesInvoices from "../pages/SalesInvoices";
import PurchaseInvoices from "../pages/PurchaseInvoices";
import BankStatements from "../pages/BankStatements";
import OtherDocuments from "../pages/OtherDocuments";
import UploadHistory from "../pages/UploadHistory";
import RecycleBin from "../pages/RecycleBin";
import IntegrationData from "../pages/IntegrationData";
import Contacts from "../pages/Contacts";
import ChartOfAccounts from "../pages/ChartOfAccounts";
import PaymentMethods from "../pages/PaymentMethods";
import VATGSTRates from "../pages/VATGSTRates";
import ComingSoon from "../pages/ComingSoon";


export interface SidebarItemType {
    name: string;
    Icon: IconType;
    link: string;
    selected?: boolean;
    element: () => JSX.Element;
    protected?: boolean;
    /**
     * Set to `true` to swap the page's element for the Coming Soon placeholder
     * without removing it from the sidebar. Optionally pass a string for the
     * ETA badge (e.g. "Q3 2026").
     */
    comingSoon?: boolean | string;
}

// Wrap a real page so it shows Coming Soon when the flag is set.
function withComingSoon(item: SidebarItemType): SidebarItemType {
    if (!item.comingSoon) return item;
    const eta = typeof item.comingSoon === 'string' ? item.comingSoon : undefined;
    const Page = () => <ComingSoon title="Coming Soon" eta={eta} />;
    return { ...item, element: Page };
}

const RawLinks: SidebarItemType[] = [
    { name: "Dashboard",         Icon: RiDashboardFill,   link: "/dashboard",          element: Dashboard },
    { name: "Sale Invoices",     Icon: HiDocumentReport,  link: "/sales-invoices",     element: SalesInvoices },
    { name: "Purchase Invoices", Icon: RiDraftFill,       link: "/purchase-invoices",  element: PurchaseInvoices },
    // Bank Statements page is mock-data only — flag as Coming Soon until wired.
    { name: "Bank Statements",   Icon: RiBankFill,        link: "/bank-statements",    element: BankStatements,  comingSoon: true },
    { name: "Other Documents",   Icon: HiDocument,        link: "/other-documents",    element: OtherDocuments },
    // Upload History is mock-data only.
    { name: "Upload History",    Icon: FaHistory,         link: "/upload-history",     element: UploadHistory,   comingSoon: true },
    { name: "Recycle Bin",       Icon: FaTrash,           link: "/recycle-bin",        element: RecycleBin },
    { name: "Integration Data",  Icon: AiFillDatabase,    link: "/intregration-data",  element: IntegrationData },
    { name: "Contacts",          Icon: RiContactsBookFill,link: "/contacts",           element: Contacts },
    { name: "Chart of Accounts", Icon: RiSurveyFill,      link: "/chart-of-accounts",  element: ChartOfAccounts },
    { name: "Payment Methods",   Icon: HiCreditCard,      link: '/payment-methods',    element: PaymentMethods },
    { name: "VAT/GST Rates",     Icon: FaReceipt,         link: '/vat-gst-rates',      element: VATGSTRates },
];

const Links: SidebarItemType[] = RawLinks.map(withComingSoon);

export default Links;
